export default function ({ store, redirect }) {
  if (!store.getters['user/allEnabledFeatures'].includes('rq-ratings-addon')) {
    return redirect('/');
  }
}
